import React  from 'react';
import { useDispatch } from 'react-redux';
import { openDeleteBrModal, openEditBrModal } from '../../Store/Slices/brSlice';
import { PaginationDetails } from '../../Utils/Utils';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Pagination , Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';



const BrList = ({data}) => {
    const dispatch = useDispatch();
    const { page, count, handleChange, _DATA } = PaginationDetails(data);

    const handleEdit = (brId) => {
        dispatch(openEditBrModal(brId));
    };

    const handleDelete = (brId) => {
        dispatch(openDeleteBrModal(brId));
    };

    const currentData = _DATA?.currentData() || data;

    const roles = sessionStorage.getItem("roles");

    return (
        <>
            <TableContainer sx={{ height: "43rem" }} >
                <Table  sx={{borderCollapse:'separate' , borderSpacing:'0px 4px' , height:'max-content'}} stickyHeader>
                    <TableHead  >
                        <TableRow >
                            <TableCell  width={50} >Role Id</TableCell>
                            <TableCell  width={50}> Role Name </TableCell>
                            <TableCell align="center" width={"30%"}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {currentData.map((br) => (
                            <TableRow  sx={{ height: "30px" }} key={br.brId}>
                                <TableCell  component='th' scope='row' sx={{ borderBottom: "none", fontWeight: 'bold', width: 100, height: 'auto !important' }}>#{br.brId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 100, height: 'auto !important' }}>{br.brName}</TableCell>
                                <TableCell align="center" sx={{ borderBottom: "none", width: '15%', height: 'auto !important' }}>
                                    {roles?.split(",").includes("PRIV_ES_EDIT_ROLE") ?  (<IconButton onClick={() => handleEdit(br.brId)}>
                                        <EditIcon />
                                    </IconButton>) : null}
                                    {roles?.split(",").includes("PRIV_ES_DELETE_ROLE") ?   (<IconButton onClick={() => handleDelete(br.brId)}>
                                        <DeleteIcon />
                                    </IconButton>) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    page={page}
                    onChange={handleChange}
                    variant='outlined'
                    color="primary"
                    size='large'
                />
            </Box>
                
        
          
        </>
    );
};


export default BrList;